import Api from "./Api";
import Utils from "../utilities/Utils";
import { Article, HelpCenter, PublicLocale, Locale } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class ArticlesController extends Api {
  static getArticles(helpCenterId: string, params: object) {
    return fetch(
      `/api/help_centers/${helpCenterId}/articles?${SearchHelper.getQueryString(
        params
      )}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static getArticle(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/articles/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(helpCenterId: string, article: Article) {
    return fetch(`/api/help_centers/${helpCenterId}/articles`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ article: article }),
    }).then((res) => res.json());
  }

  static update(helpCenterId: string, article: Article) {
    return fetch(`/api/help_centers/${helpCenterId}/articles/${article.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ article: article }),
    }).then((res) => res.json());
  }

  static delete(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/articles/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(
    helpCenterId: string,
    params: { id?: string }
  ): Promise<{
    article: Article;
    help_center: HelpCenter;
  }> {
    return fetch(
      `/api/help_centers/${helpCenterId}/articles/form?${Utils.encodeQueryData(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
